import { DropDown } from '../../base/DropDown/DropDown';
import { SortDownIcon } from '../../icons/SortDownIcon';
import { SortUpIcon } from '../../icons/SortUpIcon';
import {
  StyledActionButton,
  StyledSortableDropdown,
} from './SortableDropDown.style';

export const SORT_DIRECTIONS = {
  ASC: 'asc',
  DESC: 'desc',
};

export function SortableDropDown(props) {
  const {
    children,
    onChange,
    defaultValue,
    placeholder,
    value,
    onSortClick,
    sortDirection = SORT_DIRECTIONS.DESC,
  } = props;
  return (
    <StyledSortableDropdown>
      <DropDown
        defaultValue={defaultValue}
        onChange={onChange}
        value={value}
        placeholder={placeholder}
      >
        {children}
      </DropDown>
      <StyledActionButton
        onClick={() =>
          onSortClick(
            sortDirection === SORT_DIRECTIONS.ASC
              ? SORT_DIRECTIONS.DESC
              : SORT_DIRECTIONS.ASC,
          )
        }
        data-testid='sort-button'
      >
        {sortDirection === SORT_DIRECTIONS.DESC ? (
          <SortDownIcon />
        ) : (
          <SortUpIcon />
        )}
      </StyledActionButton>
    </StyledSortableDropdown>
  );
}
